// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/typedef */
import { configuration } from '@syllepsis/adapter';
import { Card } from '@syllepsis/access-react';

const videoConfiguration = {
  name: 'video',
  tagName: () => 'a',
  parseDOM: [
    {
      tag: 'iframe',
      getAttrs: (dom: HTMLIFrameElement) => {
        const { src } = dom;

        if (!src) {
          return false;
        }

        return {
          src,
          width: dom.width,
          height: dom.height,
        };
      },
    },
  ],
  attrs: {
    src: {
      default: '',
    },
    width: {
      default: 375,
    },
    height: {
      default: 100,
    },
  },
};

const VideoMask = ({ attrs }: { attrs: any }) => (
  // 这里不要使用 style-component
  // 传输的是 html 文本，渲染会无法关联到样式
  <div className="iframe-wrapper">
    <iframe
      sandbox="allow-scripts allow-same-origin allow-popups allow-presentation allow-forms"
      allowFullScreen={false}
      allow="encrypted-media;"
      className="iframe-border"
      src={attrs.src}
      width="731px"
      height="441px"
      style={{ background: 'transparent', border: '1px solid #dee0e3' }}
    />
  </div>
);

@configuration({
  ...videoConfiguration,
})
export class VideoView extends Card<any> {
  public ViewMap = {
    template: VideoMask, // getHtml() 获取到的内容
    mask: VideoMask, // 容器内的展现
  };

  // public renderer = this.mount({ name: 'video' });
}
